/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import "../css/register.css";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import { backend_url } from "../App.js";

function ResetPassword() {
    // Get userID from url
    let current_url = window.location.href.split("/");
    let userID = current_url[current_url.length - 1];

    const [data, setData] = useState({
        password: "",
        userId: userID
    })
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setErrorMessage] = useState('');
    const [correct, setCorrectMessage] = useState('');

    const handleChange = ({currentTarget: input }) => {
        setData({ ...data, [input.name]:input.value });
    }

    // Send post request to the user validation on submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        // Make sure the passwords match
        if (data.password !== confirmPassword) {
            setErrorMessage("Passwords do not match");
            return;
        } 
        else {
            try {
                //send post request to the 'api/resetPassword' endpoint, which resets the user's password                
                const response = await axios.post(backend_url + 'resetPassword', data);
                console.log(response)
                if (response.status === 202) {
                    setCorrectMessage("Your password has successfully been reset");
                }
            } 
            catch (error) {
                if (error.response && error.response.status >= 400 && error.response.status <= 500) {
                    setErrorMessage(error.response.data.message);
                }
            }
        }
    };

    //show or hide password
    const [state, setState] = useState(false);

    const toggleBtn = () => {
        setState(prevState => !prevState);
    }

    return (
        <>
            <>
                <meta charSet="UTF-8" />
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>Reset Password</title>
                <link href='https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css' rel='stylesheet' />
                <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;600;700&display=swap" rel="stylesheet" />
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
            </>

            <section className="container">
                <div className="form regis" id="regis">
                    <div className="form-content">
                        <header>Reset Password</header>
                        {error && <div style={{color:"red", textAlign: "center", paddingTop: "15px"}}>{error}</div>}
                        {correct && <div style={{color: "green", textAlign: "center", paddingTop: "15px"}}>{correct}</div>} 
                        <form action="#" onSubmit={handleSubmit}>
                            <div className="field input-field">
                                <label for="password" class="visuallyhidden">Password</label>
                                <input
                                    type={state ? "text" : "password"}
                                    placeholder="New Password"
                                    className="password"
                                    name="password"
                                    value={data.password}
                                    onChange={handleChange}
                                    required
                                />
                                <div onClick={toggleBtn}>
                                    <i className={state ? "bx bx-show eye-icon" : "bx bx-hide eye-icon"}></i>
                                </div>
                            </div>
                            <div className="field input-field">
                                <label for="confirm" class="visuallyhidden">Confirm Password</label>
                                <input
                                    type={state ? "text" : "password"}
                                    placeholder="Confirm Password"
                                    className="password"
                                    value={confirmPassword}
                                    name="confirm"
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                                <div onClick={toggleBtn}>
                                    <i className={state ? "bx bx-show eye-icon" : "bx bx-hide eye-icon"}></i>
                                </div>
                            </div>
                            <div>
                                <p id="pass-req">
                                    Passwords should:
                                    <ul>
                                        <li>Be between 8 and 26 characters long</li>
                                        <li>Contain at least one uppercase and lowercase character</li>
                                        <li>Contain at least one numeric value</li>
                                        <li>Contain at least one symbol</li>
                                    </ul>
                                </p>
                            </div>
                            <div className="field button-field">
                                <button type="submit">Register</button> 
                            </div>
                            <div className="form-link">
                                <span>Go Back to <Link to='/' className="link sign-up-link"> Login </Link></span>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ResetPassword;